import { Button } from '../components/Button';
import background from '../assets/background.svg';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useSubscriptionTerms } from '../components/terms/AcceptanceTerms';
import { NotificationTerms } from '../components/terms/NotificationTerms';
import DotSpinner from '../components/shared/DotSpinner';
import { useEffect, useState } from 'react';
import config from '../config';

export default function HomePage() {
  const navigate = useNavigate();
  const location = useLocation();

  const [isLoading, setIsLoading] = useState(true);
  const { CheckBox, isChecked } = useSubscriptionTerms();

  const handleStart = () => {
    if (!isChecked)
      return toast.info('Пожалуйста, подтвердите согласие с правилами сервиса и обработкой данных под кнопкой');
    navigate('/calculatePage');
  };

  useEffect(() => {
    const steps = location.state?.steps || [];

    if (steps.length > 0) {
      navigate(config.ROUTES.CALCULATE, { state: { steps } });
    } else {
      setIsLoading(false);
    }
  }, [location]);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-[100vh] [background:linear-gradient(180deg,rgb(1,13,13)_0%,rgb(3.01,42.5,42.5)_100%)] bg-[100%_100%] bg-repeat-y bg-cover">
        <DotSpinner />
      </div>
    );
  }

  return (
    <div className="relative w-[100%] h-[100%] overflow-x-hidden overflow-y-hidden">
      <img src={background} className="absolute inset-0 w-full" />
      <div className="absolute bottom-1/3 inset-0 flex flex-col justify-center items-center">
        <img src="/logo-new.png" alt="logo" className="z-1 w-[273px] mx-auto" />
      </div>
      <div className="absolute z-10 bottom-4 right-4 left-4 pointer-events-none">
        <Button
          onClick={handleStart}
          id="jnl7j4km1wh"
          className={`pointer-events-auto w-full ${!isChecked && 'opacity-30'}`}
        >
          Начать
        </Button>

        <NotificationTerms />
        <CheckBox />
      </div>
    </div>
  );
}
